module.exports = __webpack_public_path__ + "img/footer-icon-row-light-ford.148b7dfb.png";